module.exports = __webpack_public_path__ + "img/douyin.a524b83.svg";